<template>
    <div class="tsa-checkboxV2" :class="[value === trueLabel ? 'checked' : '', indeterminate ? 'indeterminate' : '', disabled ? 'disabled' : '']" @click="choose">
        <span class="icon" :style="{ color: value === trueLabel ? color : '' }" :class="disabled ? iconType[shape].false : value === trueLabel ? iconType[shape].true : indeterminate ? iconType[shape].indeterminate : iconType[shape].false "></span>
        <p><slot></slot></p>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: [Boolean, String, Number, null],
            default: false
        },
        trueLabel: {
            type: [Boolean, String, Number, null],
            default: true
        },
        falseLabel: {
            type: [Boolean, String, Number, null],
            default: false
        },
        indeterminate: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        shape: {
            type: String,
            default: 'round' // square
        },
        color: {
            type: String,
            default: '#14AE5C'
        },
    },
    data () {
        return {
            iconType: {
                round: {
                    true: 'tsa-icon-piliang-quanxuan',
                    false: 'tsa-icon-piliang-weixuan',
                    indeterminate: 'tsa-icon-piliang-banxuan'
                },
                square: {
                    true: 'tsa-icon-duoxuan-quanxuan',
                    false: 'tsa-icon-duoxuan-weixuan',
                    indeterminate: 'tsa-icon-duoxuan-banxuan'
                }
            }
        }
    },
    methods: {
        choose () {
            if (this.disabled) {
                return
            }
            let value
            if (this.value !== this.trueLabel) {
                value = this.trueLabel
            } else if (this.value === this.trueLabel) {
                value = this.falseLabel
            } else {
                value = !this.value
            }
            this.$emit('input', value)
            this.$emit('on-change', value)
        }
    }
}
</script>

<style lang="scss" scoped>
    .tsa-checkboxV2 {
        display: flex;
        align-items: center;
        cursor: pointer;
        &.checked {
            .icon {
                color: #14AE5C;
            }
        }
        &.indeterminate {
            .icon {
                color: #14AE5C;
            }
        }
        &.disabled {
            cursor: not-allowed;
            .icon {
                color: #999999!important;
            }
            p {
                color: #999999!important;
            }
        }
        .icon {
            color: #B3B3B3;
            font-size: 14px;
            margin-right: 6px;
        }
        p {
            font-size: 14px;
            color: #000000;
        }
    }
</style>